import hotgadgets from '../images/hotgadgets.png';
import eschool from '../images/eschool.png';
import redonion from '../images/redonion.png';
import volunteernetwork from '../images/volunteernetwork.png';
import resultgrading from '../images/resultgrading.png';
import bocweb from '../images/bocweb.png';
import ichat from '../images/ichat.png';
import doctorsp from '../images/doctorsp.png';
import gb2021 from '../images/gb2021.png';
import classified from '../images/classified.png';

let webWorksData = [
    {
        name: 'Result Grading',
        type: 'Static Front-End',
        technologies: ['HTML', 'CSS', 'JavaScript'],
        link: 'https://lmtonay.github.io/result-grading/',
        image: resultgrading
    },
    {
        name: 'GonitBid 2021',
        type: 'Online Contest',
        technologies: ['HTML', 'CSS', 'JavaScript', 'React', 'Node', 'Express', 'MongoDB', 'Bootstrap'],
        link: 'https://gonitbid-2021.web.app',
        image: gb2021
    },
    {
        name: 'Hot Gadgets',
        type: 'Static Front-End',
        technologies: ['HTML', 'CSS', 'Bootstrap'],
        link: 'https://lmtonay.github.io/hot-gadgets/',
        image: hotgadgets
    },
    {
        name: 'E-School',
        type: 'Static Front-End',
        technologies: ['HTML', 'CSS', 'Bootstrap'],
        link: 'https://lmtonay.github.io/e-school/',
        image: eschool
    },
    {
        name: 'Doctors Portal',
        type: 'Dynamic Front-End',
        technologies: ['HTML', 'CSS', 'Bootstrap', 'React', 'React-Calender', 'Material UI'],
        link: 'https://doctors-portal-site.netlify.app',
        image: doctorsp
    },
    {
        name: 'Red Onion',
        type: 'Dynamic Front-End',
        technologies: ['HTML', 'CSS', 'Bootstrap', 'React', 'Firebase', 'Redux'],
        link: 'https://red-onion-site.netlify.app',
        image: redonion
    },
    {
        name: 'Volunteer Network',
        type: 'Full Stack',
        technologies: ['HTML', 'CSS', 'Bootstrap', 'React', 'Material UI', 'Node', 'Express', 'MongoDB'],
        link: 'https://volunteer-network-c64b7.web.app/',
        image: volunteernetwork
    },
    {
        name: 'Bangladesh Olympiadians Club',
        type: 'Static Front-End (WIP)',
        technologies: ['HTML', 'CSS', 'Bootstrap', 'AOS', 'JavaScript', 'BootstrapMade Theme Customization'],
        link: 'https://boc-website.netlify.app',
        image: bocweb
    },
    {
        name: 'iChat - Worldwide GC',
        type: 'Full Stack',
        technologies: ['HTML', 'CSS', 'JavaScript', 'Node', 'Socket.io'],
        link: 'https://lmtonay.github.io/iChat',
        image: ichat
    },
    {
        name: 'Classified - Ad Listing Site',
        type: 'React Front-End',
        technologies: ['React', 'Mapbox GL', 'Swiper', 'Bootstrap', 'CSS', 'JavaScript'],
        link: 'https://classified-demo-dev.web.app/',
        image: classified
    }
];

for (let i = 0; i < webWorksData.length; i++){
    webWorksData[i].id = i + 1;
};

webWorksData.reverse();

webWorksData = webWorksData.slice(0, 6);

export default webWorksData;